import PropTypes from 'prop-types';
import React, { Component, PureComponent } from 'react';
import Avatar from './avatar.ui.jsx';
import Initials from './initials.ui.jsx';
import { Link } from 'react-router';
import { Button, Wrapper, Menu, MenuItem } from 'react-aria-menubutton';
import { KEYS } from 'const';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { analyticsEvent } from '../actions/analytics';

const { ENTER, SPACE, UP, DOWN, LEFT, RIGHT } = KEYS;

class ArrowTrap extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
    };

    componentDidMount() {
        document.addEventListener('keydown', this.arrowListener);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.arrowListener);
    }

    arrowListener = e => {
        const focused = document.querySelector(':focus');
        if (focused && focused.getAttribute('role') === 'menuitem') return;
        e.preventDefault();
        if ([UP, LEFT].includes(e.which)) {
            this.moveFocus(e);
        }
        if ([DOWN, RIGHT].includes(e.which)) {
            this.moveFocus(e, true);
        }
    };

    moveFocus(event, prev = false) {
        event.preventDefault();
        const focusableElements = [
            ...document.querySelectorAll('.user-menu .dropdown-container a'),
        ];
        const focusedElement = document.querySelector(':focus');
        const index = focusableElements.indexOf(focusedElement);
        const nextElement = focusableElements[prev ? index + 1 : index - 1];
        if (nextElement) {
            nextElement.focus();
        } else {
            focusableElements[prev ? 0 : focusableElements.length - 1].focus();
        }
    }

    render() {
        return this.props.children;
    }
}

class UserMenu extends PureComponent {
    static displayName = 'UserMenu';

    static propTypes = {
        analyticsEvent: PropTypes.func.isRequired,
        contentLink: PropTypes.string,
        email: PropTypes.string.isRequired,
        helpUrl: PropTypes.string,
        name: PropTypes.string.isRequired,
        push: PropTypes.func.isRequired,
        termId: PropTypes.number.isRequired,
    };

    trackHelp = () => this.props.analyticsEvent('help-link', 'click');

    onSelection = (element, e) => {
        /* This is a workaround for a bug in react-aria-menubutton */
        if ([ENTER, SPACE].includes(e.which)) {
            const { to, href, target } = element.props;
            if (to) {
                this.props.push(to);
            } else if (href) {
                if (target === '_blank') {
                    window.open(href, '_blank', 'noopener,noreferrer');
                } else {
                    window.location.href = href;
                }
            }
        }
    };

    render() {
        return (
            <Wrapper className="user-menu" onSelection={this.onSelection}>
                <Button aria-label="User menu">
                    <Initials name={this.props.name} />
                </Button>
                <Menu>
                    <ArrowTrap>
                        <div className="dropdown-container">
                            <div className="user-menu-avatar">
                                <div className="avatar-wrapper">
                                    <Avatar email={this.props.email} />
                                </div>
                                <span>{this.props.name}</span>
                                <span>{this.props.email}</span>
                            </div>

                            <div className="btn-primary">
                                <MenuItem className="btn-primary">
                                    <a
                                        onClick={this.trackHelp}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={this.props.helpUrl}
                                        className="btn btn-primary"
                                        style={{ width: '100%' }}
                                    >
                                        Help
                                        <span className="aural">
                                            (opens in new window)
                                        </span>
                                    </a>
                                </MenuItem>
                            </div>

                            <div className="base">
                                <MenuItem>
                                    <Link
                                        to={`/term/${this.props.termId}/logout`}
                                    >
                                        Logout
                                    </Link>
                                </MenuItem>
                                <p>{'\u00b7'}</p>
                                <MenuItem>
                                    <a
                                        href={`${window.location.origin}/privacy-policy.html`}
                                        rel="noreferrer noopener"
                                        target="_blank"
                                    >
                                        Privacy Policy
                                        <span className="aural">
                                            (opens in new window)
                                        </span>
                                    </a>
                                </MenuItem>
                                <p>{'\u00b7'}</p>
                                <MenuItem>
                                    <a
                                        href={`${window.location.origin}/eula.html`}
                                        rel="noreferrer noopener"
                                        target="_blank"
                                    >
                                        Terms of Use
                                        <span className="aural">
                                            (opens in new window)
                                        </span>
                                    </a>
                                </MenuItem>
                            </div>
                        </div>
                    </ArrowTrap>
                </Menu>
            </Wrapper>
        );
    }
}

export default connect(
    ({
        current_user: {
            user: {
                email,
                first_name,
                last_name,
                content_link: { show_link, url },
            },
        },
        currentTerm,
        customer: { help_url },
    }) => ({
        email,
        helpUrl: help_url,
        name: first_name + ' ' + last_name,
        termId: Number(currentTerm),
        contentLink: show_link ? url : null,
    }),
    { push, analyticsEvent }
)(UserMenu);



// WEBPACK FOOTER //
// ./src/components/user_menu.ui.jsx